module.exports = __webpack_public_path__ + "img/TheVillageofSkokie.99e2654e.png";